import React from 'react';
import { Table, Dropdown, Icon } from 'semantic-ui-react';
import { formatBatchProductCell } from '../../utilities/productUtil';
import { sellerGuaranteeProductTypes } from '../../constants/product';

// New Offer adds a DealShield-priced offer without a product, and Tappy will not accept a batch
// that mixes Seller Guarantee with anything else
export const canAddOffer = flatRateOffers => !(flatRateOffers || [])
  .some(offer => sellerGuaranteeProductTypes.includes(offer.productType));

const ListRow = actionHandler => flatRateOfferBatch => {
  const {
    id,
    createdAt,
    offeringUsersEmails,
    approved,
    state,
    auctionAccessNo,
    buyerInformation,
    offeredDealerNumbers,
    salesRepEmail,
    expirationDate,
    acceptingUserName,
    flatRateOffers,
  } = flatRateOfferBatch;

  const { name: buyerName, emails: buyerEmails } = buyerInformation || {};

  const rowMenuOptions = state === 'void'
    ? [
      { key: 6, text: 'View', value: 'Edit' },
      { key: 5, text: 'Delete', value: 'Delete' },
    ]
    : [
      { key: 1, text: 'Reset', value: 'Reset' },
      { key: 2, text: 'Confirm', value: 'Confirm' },
      { key: 3, text: 'Edit', value: 'Edit' },
      ...(canAddOffer(flatRateOffers) ? [{ key: 4, text: 'New Offer', value: 'AddNewOffer' }] : []),
      { key: 5, text: 'Delete', value: 'Delete' },
    ];
  const handleActionChange = (e, { value }) => {
    e.preventDefault();
    actionHandler(value, flatRateOfferBatch);
  };

  const formatedEmails = emailList => `${emailList && emailList.replace(/,/g, ', ')}`;
  const filterDuplicated = valueList => {
    const values = valueList && valueList.split(',').map(value => value.trim());
    return [...new Set(values)].join(', ');
  };

  return (
    <Table.Row key={id}>
      <Table.Cell>{createdAt}</Table.Cell>
      <Table.Cell>
        {offeringUsersEmails && filterDuplicated(formatedEmails(offeringUsersEmails))}
      </Table.Cell>
      <Table.Cell>
        {approved && <Icon color='green' name='checkmark' size='large' />}
        {!approved && <Icon color='red' name='close' size='large' />}
      </Table.Cell>
      <Table.Cell>{state}</Table.Cell>
      <Table.Cell data-testid='product-cell'>
        {formatBatchProductCell(flatRateOffers)}
      </Table.Cell>
      <Table.Cell>{auctionAccessNo}</Table.Cell>
      <Table.Cell>{buyerName}</Table.Cell>
      <Table.Cell>{buyerEmails && filterDuplicated(formatedEmails(buyerEmails))}</Table.Cell>
      <Table.Cell>{offeredDealerNumbers.join(',')}</Table.Cell>
      <Table.Cell className='word-break-word'>{salesRepEmail && formatedEmails(salesRepEmail)}</Table.Cell>
      <Table.Cell>{filterDuplicated(acceptingUserName)}</Table.Cell>
      <Table.Cell>{expirationDate}</Table.Cell>
      <Table.Cell>
        <Dropdown
          text='Actions'
          options={rowMenuOptions}
          icon='ellipsis horizontal'
          onChange={handleActionChange}
          inline
          item
          selectOnBlur={false}
          value={null}
        />
      </Table.Cell>
    </Table.Row>
  );
};

export default ListRow;
